<template>
    <v-layout>
        <v-container v-if="showui" fluid>
            <v-snackbar v-model="snack.show" :color="snack.color" multi-line right :timeout="3000" top>{{ snack.text }}
                <v-btn dark text @click="snack.show = false">Скрыть</v-btn>
            </v-snackbar>
            <v-card>
                <v-card-title>Группы пользователей</v-card-title>
                <v-card-text>
                    <div>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="usersTable.search"
                                              placeholder="Введите фразу для поиска" clearable clear-icon="mdi-close-circle-outline"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox v-model="usersTable.newbie" @change="getUsers()"
                                            label="Только нераспределенные"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-data-table
                                :headers="usersTable.headers"
                                :items="usersTable.users"
                                :page.sync="usersTable.page"
                                :loading="usersTable.load"
                                :search="usersTable.search"
                                hide-default-footer
                                class="elevation-1"
                                :items-per-page="25"
                                @page-count="usersTable.pageCount = $event"
                        >
                            <template v-slot:top>
                                <v-toolbar flat color="white">
                                    <v-dialog v-model="editDialog" max-width="500px">
                                        <v-card>
                                            <v-card-title>
                                                <span class="headline">Редактировать</span>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" sm="6" md="6">
                                                            <v-text-field disabled v-model="editedItem.first_name"
                                                                          label="Имя"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="6">
                                                            <v-text-field disabled v-model="editedItem.last_name"
                                                                          label="Фамилия"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" sm="12" md="12">
                                                            <v-text-field disabled v-model="editedItem.phone"
                                                                          label="Телефон"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field v-model="editedItem.address"
                                                                          label="Адрес"></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-select dense :items="['sto', 'uk', 'franch']" label="Тип" v-model="editedItem.user_type"></v-select>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-select v-if="editedItem.user_type === 'uk'" dense :items="groups" label="Группа" v-model="editedItem.group_or_position"></v-select>
                                                            <v-select v-if="editedItem.user_type === 'franch'" dense :items="positions" label="Должность" v-model="editedItem.group_or_position"></v-select>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="editDialog = false">Отмена
                                                </v-btn>
                                                <v-btn color="blue darken-1" text @click="saveUser">Сохранить</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:item.group_or_position="{ item }">
                                <v-select v-if="item.user_type === 'uk'" disabled dense :items="groups"
                                          v-model="item.group_or_position"></v-select>
                                <v-select v-if="item.user_type === 'franch'" disabled dense :items="positions"
                                          v-model="item.group_or_position"></v-select>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                            </template>
                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination v-model="usersTable.page" :length="usersTable.pageCount"></v-pagination>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
            <v-dialog v-model="loaderDialog" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Загрузка данных
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
        <v-container v-else fluid><h1>Вам не доступен этот интерфейс</h1></v-container>

    </v-layout>
</template>
<script>
  import moment from 'moment'
  import tz from 'moment-timezone'
  import Fingerprint2 from 'fingerprintjs2'

  const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
  export default {
    data: () => ({
      showui: false,
      editDialog: false,
      snack: {
        color: 'info',
        text: null,
        show: false,
      },
      groups: [],
      positions: [],
      editedIndex: null,
      editedItem: {
        id: 0,
        first_name: null,
        last_name: null,
        group_or_position: null,
        address: null,
        user_type: null,
        phone: null
      },
      loaderDialog: false,
      usersTable: {
        search: null,
        newbie: false,
        headers: [
          {
            text: 'Фамилия',
            align: 'left',
            sortable: false,
            value: 'last_name',
          },
          {
            text: 'Имя',
            align: 'left',
            sortable: false,
            value: 'first_name',
          },
          { text: 'Telegram ID', value: 'telegram_id' },
          { text: 'Телефон', value: 'phone' },
          { text: 'Email', value: 'login' },
          { text: 'Адрес', value: 'address' },
          { text: 'Тип', value: 'user_type' },
          { text: 'Группа/Должность', value: 'group_or_position' },
          { text: 'Actions', value: 'action', sortable: false },
        ],
        users: [],
        options: {},
        page: 1,
        load: false,
        pageCount: 0,
      }
    }),
    watch: {},
    filters: {},
    computed: {},
    filters: {},
    methods: {
      showSnack: function (text = 'info', color = 'info') {
        this.snack.text = text
        this.snack.color = color
        this.snack.show = true
      },
      searchFiles: async function () {

      },
      loader: function (mode = false) {
        if (mode === 'on' || mode === 1 || !!mode) {
          this.usersTable.load = true
        } else {
          this.usersTable.load = false
        }
      },
      sameAccess: async function () {

      },
      editItem: function (item) {
        this.editedIndex = this.usersTable.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editDialog = true
      },
      saveUser: async function () {
        try {
          const r = await this.$http.put(`${this.$store.getters.api}v4/bxdrive/users`, {
            id: this.editedItem.id,
            gp: this.editedItem.group_or_position,
            ut: this.editedItem.user_type
          })

          this.editedItem = {
            id: 0,
            first_name: null,
            last_name: null,
            group_or_position: null,
            user_type: null,
            address: null,
            phone: null
          }
          this.showSnack('Пользователь сохранен', 'success')
        } catch (e) {
          console.log(e)
        }
        this.getUsers()
        this.editDialog = false
      },
      getUsers: async function (offset = 0) {
        this.loader(1)
        if (!!this.usersTable.newbie) {
          try {
            const r = await this.$http.get(`${this.$store.getters.api}v4/bxdrive/users/new`)
            this.usersTable.users = r.data
          } catch (e) {
            console.log(e)
          }
        } else {
          try {
            const r = await this.$http.get(`${this.$store.getters.api}v4/bxdrive/users/all`)
            this.usersTable.users = r.data
          } catch (e) {
            console.log(e)
          }
        }

        this.loader(0)
      },
      getPositions: async function () {
        try {
          const r = await this.$http.get(`${this.$store.getters.api}service/getpositions`)
          this.positions = r.data.map(p => ({
            text: p.position_title,
            value: p.position_id
          }))
        } catch (e) {
          console.log(e)
        }
      },
      getGroups: async function () {
        try {
          const r = await this.$http.get(`${this.$store.getters.api}service/getourgroups`)
          this.groups = r.data.map(g => ({
            text: g.group_name,
            value: g.id
          }))
        } catch (e) {
          console.log(e)
        }
      },
      getAdminRights: async function () {
        this.loader(1)
        let user = JSON.parse(localStorage.getItem('user-data'))
        try {
          const r = await this.$http.get(`${this.$store.getters.api}admin/roles?user=${user.id}`)
          console.log('admin roles', r.data)
          for (let role of r.data) {
            if (role.admin_ui === 1 || role.admin_ui === '1') {
              this.showui = true
            }
          }
          await this.getGroups()
          await this.getPositions()
          this.getUsers()
        } catch (e) {
          console.log(e)
        }
        this.loader(0)

      },
      saveAccessData: async function () {

      }
    },
    mounted () {
      this.getAdminRights()

    },
  }
</script>
<style>

</style>